<template>
  <div
    class="second-point">
    <h4
      class="second-point-title"
      @click="clickTitle">
      {{ item.text }}
      <span v-if="item.nodes" class="hasLearnBox">{{ item.hasLearn || 0 }}/{{ item.nodes.length }}</span>
      <ct-icon
        :class="{'scroll': isScroll}"
        class="course-scroll"
        name="jiantouyou"
        :multi-color="false"></ct-icon>
    </h4>
    <ul
      :ref="'secondPoint'"
      class="second-point-content"
      :class="{'scroll': isScroll}"
      >
      <li
        class="third-point"
        v-for="child in item.nodes"
        @click="goLearning(child)"
        :key="child.id">
        <span class="weight-tip">{{ child.priority }}</span>
        <p class="content-text">{{ child.text }}</p>
        <span class="status-tip" :class="child.status">{{ child.status }}</span>
      </li>
      <li v-if="!(item.nodes && item.nodes.length)"
        class="third-point ">
        <p class="content-text">The course is about coming soon, stay tuned!</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'SecondPointCard',
  props: {
    item: Object
  },
  data () {
    return {
      isScroll: false
    }
  },
  methods: {
    clickTitle () {
      this.isScroll = !this.isScroll
    },
    goLearning (child) {
      if (!child.video.video_id) return
      this.$emit('clickThird', child)
    }
  },
  mounted () {
    let d = this.$refs['secondPoint']
    let h = window.getComputedStyle(d).getPropertyValue('height')
    d.style.height = h
  }
}
</script>

<style lang="scss" scoped>
.second-point {
    .second-point-title {
      margin: 0 28px;
      background:rgba(239,244,250,1);
      border-radius: 2px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(26,61,94,1);
      line-height: 32px;
      padding: 0 24px;
      position: relative;
      cursor: pointer;
      .hasLearnBox {
        background:rgba(226,233,241,1);
        border-radius:15px;
        font-size:12px;
        font-weight:400;
        color:rgba(26,61,94,1);
        padding: 3px 8px;
        margin-left: 24px;
        line-height: 14px;
        display: inline-block;
        transform: translateY(-2px);
      }
    }
    .second-point-content {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 24px 20px 0;
      margin-bottom: 24px;
      overflow: hidden;
      transition: all .5s ease;
      &.scroll {
        height: 0!important;
        margin-bottom: 0;
      }
      .third-point {
        margin: 0 1% 16px;
        width: 48%;
        padding: 24px 24px 28px;
        position: relative;
        border-radius:2px;
        border:1px solid rgba(239,244,250,1);
        transition: all .2s;
        box-shadow:0px 0px 0 0px rgba(35,62,114,0.1);
        cursor: pointer;
        .weight-tip {
          position: absolute;
          left: 0;
          top: 6px;
          border-radius: 0 15px 15px 0;
          height: 20px;
          width: 26px;
          line-height: 20px;
          text-align: center;
          text-indent: -2px;
          background: #37CAD7;
          font-size:12px;
          color:rgba(26,61,94,1);
        }
        .content-text {
          font-size:16px;
          color:rgba(26,61,94,1);
          line-height:20px;
          height: 40px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .status-tip {
          position: absolute;
          right: 8px;
          bottom: 8px;
          width: 52px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          font-size:12px;
          &.finished {
            background: rgba(55,202,215,0.1);
            color: #37CAD7;
          }
          &.Learning {
            background:rgba(250,203,88,0.1);
            color: #FACB58;
          }
        }
        &:hover {
          box-shadow:0px 2px 16px 0px rgba(35,62,114,0.07);
        }
      }
    }
    .course-scroll {
      position: absolute;
      right: 24px;
      top: 50%;
      transform: translateY(-50%) rotate(90deg);
      transition: all .5s ease;
      &.scroll {
        transform: translateY(-50%) rotate(-90deg);
      }
    }
  }
</style>
